import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import logo from "../assets/images/logo/logo279.png";
import * as actions from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import requestApi from "../helpers/apiHelper";
import { toast } from "react-toastify";

const SignIn = () => {
  const [apiError, setApiError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.globalLoading.status);

  const onFinish = (values) => {
    setApiError("");
    dispatch(actions.controlLoading(true));
    const param = { username: values.username, password: values.password };
    requestApi("/auth/login", "POST", param)
      .then((res) => {
        dispatch(actions.controlLoading(false));

        if (res.data.isSuccess) {
          dispatch(
            actions.loginSuccess(
              res.data.data.accessToken,
              res.data.data.refreshToken,
            ),
          );
          toast.success("Đăng nhập thành công!", {
            position: "top-right",
            autoClose: 3000,
          });
          navigate("/admin");
        }
      })
      .catch((err) => {
        dispatch(actions.controlLoading(false));
        console.log(err);

        const errorMessage =
          err.response?.data?.message ||
          "Vui lòng lại kiểm tra thông tin tài khoản, mật khẩu!!!";

        setApiError(errorMessage);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="login-view">
      <div className="logo-section" style={{ marginBottom: "1rem" }}>
        <h1 className="app-title">Admin</h1>
      </div>
      <div className="login-card">
        <div className="logo-section">
          <img src={logo} alt="Logo" />
        </div>

        <Form
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          className="login-form"
          autoComplete="off"
        >
          <Form.Item
            className="form-group-custom"
            label="Tài khoản / Email"
            name="username"
            validateTrigger="onSubmit"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập tài khoản",
              },
            ]}
          >
            <div className="input-wrapper-custom">
              <Input
                prefix={<MailOutlined className="input-icon" />}
                placeholder="Tài khoản"
                autoComplete="off"
              />
            </div>
          </Form.Item>

          <Form.Item
            className="form-group-custom"
            label="Mật khẩu"
            name="password"
            validateTrigger="onSubmit"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập mật khẩu",
              },
            ]}
          >
            <div className="input-wrapper-custom">
              <Input.Password
                prefix={<LockOutlined className="input-icon" />}
                placeholder="Mật khẩu"
                autoComplete="new-password"
              />
            </div>
          </Form.Item>
          {apiError && (
            <div className="login-api-error">
              {apiError}
            </div>
          )}
          <Button
            type="primary"
            htmlType="submit"
            className="btn-primary-custom w-full"
            loading={loading}
          >
            {loading ? "Đang đăng nhập..." : "Đăng nhập"}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default SignIn;
